var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flexben-dashboard mb-5"},[(_vm.userIsAdmin)?_c('AdminDashboard',{attrs:{"customer":_vm.customer}}):_vm._e(),(_vm.userIsClient)?_c('ClientDashboard',{attrs:{"customer":_vm.customer}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }